import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import Swal from 'sweetalert2';
import { RestaurantDetails } from '../../restaurants/models/List.Restaurant';
import { RestaurantService } from '../../restaurants/services/Restaurant.service';
import { DaysOffFormComponent } from './days-off-form/days-off-form.component';
import { ListData, ListFilter } from './models/List.Days';
import { UnavailableDayService } from './services/dayOff.service';

@Component({
  selector: 'app-days-off-config',
  templateUrl: './days-off-config.component.html'
})
export class DaysOffConfigComponent implements OnInit {


  dataLoading = true;
  showFilter = false;
  showSearch = false;
  pageIndex = 0;
  pageCount = 0;
  filterModel: ListFilter = new ListFilter();
  recordsData!: ListData | null;
  // Restaurant ID
  restaurantId?: any;
  allRestaurants: RestaurantDetails[] = [];
  pageSize = 10;
  constructor(private restaurantService: RestaurantService,
    public dialog: MatDialog,
    public translate: TranslateService,
    private service: UnavailableDayService) { }

  ngOnInit(): void {
    this.getAll(null)
    this.filterModel.pageSize = this.pageSize;
  }

  getAll(event: any) {
    this.dataLoading = true;
    if (!event) {
      this.pageIndex = 0;
      this.filterModel.pageSize = this.pageSize;
    }
    if (event && event.pageSize) {
      this.pageIndex = event.pageIndex;
      this.filterModel.pageSize = event.pageSize;

    }
    this.filterModel.pageNumber = this.pageIndex;

    this.service.getAll(this.filterModel).subscribe(
      (data: ListData) => {
        this.dataLoading = false;
        if (data) {
          this.recordsData = data;
          this.pageCount = Math.ceil(this.recordsData.totalCount / this.filterModel.pageSize);
          setTimeout(() => {
            window.scrollTo({
              top: (document.getElementsByClassName('table-responsive')[0] as HTMLElement)?.offsetTop - 200,
              behavior: "smooth"
            });
          }, 10);
        }
      },
      (error: any) => {
        this.recordsData = null;
        this.dataLoading = false;
      });


  }
  openDayForm(record: any | null = null) {
    const dialogRef = this.dialog.open(DaysOffFormComponent, {
      width: '530px',
      data: { record }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.getAll(true);
      }
    });
   }

  deleteRecord(recordId: any) {
    Swal.fire({
      title: this.translate.instant('swalMsg.Areyousuretodelete'),
      text: '',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: this.translate.instant('swalMsg.Yesdeleteit'),
      cancelButtonText: this.translate.instant('swalMsg.Nokeepit')
    }).then((result) => {
      if (result.value) {
        this.dataLoading = true;
        this.service.delete(recordId).subscribe(
          (data: any) => {
            if (data) {
              Swal.fire({
                title: this.translate.instant('swalMsg.Success'),
                text: this.translate.instant('swalMsg.deletededsuccessfuly'),
                icon: 'success',
                confirmButtonText: this.translate.instant('swalMsg.Ok')
              });
              this.getAll(true);
            }
          },
          (error: any) => {
            this.dataLoading = false;
            Swal.fire({
              title: this.translate.instant('swalMsg.Failed'),
              text: error.detail,
              icon: 'error',
              confirmButtonText: this.translate.instant('swalMsg.Ok'),
            });
          });
      }
    });
  }

  changeStatus(recordId: any, status: boolean) {
    Swal.fire({
      title: this.translate.instant('swalMsg.Areyousure'),
      text: '',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: this.translate.instant('swalMsg.Yes'),
      cancelButtonText: this.translate.instant('swalMsg.No')
    }).then((result) => {
      if (result.value) {
        this.service.changeStatusUnavailableDay(recordId, status).subscribe(
          (data: any) => {
            if (data) {
              Swal.fire({
                title: this.translate.instant('swalMsg.Success'),
                text: this.translate.instant('swalMsg.updatedsuccessfully'),
                icon: 'success',
                confirmButtonText: this.translate.instant('swalMsg.Ok')
              });
              this.getAll(true);
            }
          },
          (error: any) => {
            Swal.fire({
              title: this.translate.instant('swalMsg.Failed'),
              text: error.detail,
              icon: 'error',
              confirmButtonText: this.translate.instant('swalMsg.Ok'),
            });
          })
      }
    });
  }

}
